import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '使用指南', href: '/category/guide' },
      { label: '功能介绍', href: '/category/feature' },
      { label: '常见问题', href: '/category/faq' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '最新动态', href: '/category/news' },
      { label: '安全中心', href: '/category/security' },
      { label: '技巧分享', href: '/category/tips' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/category/faq' },
      { label: '使用指南', href: '/category/guide' },
      { label: '联系我们', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 hover:text-primary-300 transition-colors whitespace-nowrap">
              17c.cc
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-400">
              17c.cc 优质综合平台，提供官方入口、使用指南、功能介绍及问题解答，致力于为用户提供流畅便捷的在线体验。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 17c.cc 版权所有 | 17c.cc官方入口
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-primary-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-300 transition-colors" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-300 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}